"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safetyValvesCertificateRenderer = exports.SafetyValveCertificatesRenderer = void 0;
const app_1 = require("app");
const Service_1 = require("./api/Service");
const SafetyValveCertificates_1 = require("./SafetyValveCertificates");
class SafetyValveCertificatesRenderer extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.safety-valve-certificates';
    }
    OnInit() {
        let safetyValveCertificatesApi = null;
        const config = app_1.ConfigService.GetData() || {};
        if (config && config.safetyValveCertificatesApi) {
            safetyValveCertificatesApi = config.safetyValveCertificatesApi;
        }
        const service = new Service_1.default({ safetyValveCertificatesApi });
        (0, SafetyValveCertificates_1.RenderSafetyValveCertificates)({ service }, this.el[0]);
    }
}
exports.SafetyValveCertificatesRenderer = SafetyValveCertificatesRenderer;
exports.safetyValvesCertificateRenderer = new SafetyValveCertificatesRenderer();
